/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgNavigation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M22.03 1.97a.75.75 0 01.148.851l-9 19a.75.75 0 01-1.406-.14l-1.89-7.563-7.564-1.89a.75.75 0 01-.14-1.406l19.001-9a.75.75 0 01.851.148zM4.715 11.28l5.967 1.492a.75.75 0 01.546.546l1.491 5.967 7.204-15.208L4.715 11.28z'
      />
    </svg>
  );
}

export default SvgNavigation;
